/**
 * 本地数据缓存
 * 存储在这里面的必须是 全局 多处 长期 需要使用的数据
 */
import utils from "@/utils/utils";

const types = {
  userinfo: 'LLM_USER_INFO',
  mobileAccountInfo: 'LLM_MOBILE_ACCOUNT_INFO',
  mobilePayInfo: 'LLM_MOBILE_PAY_INFO',
  mobilePayNewInfo: 'LLM_MOBILE_PAY_NEW_INFO',
  shareUserList: 'LLM_SHARE_USER_LIST',
  transferUserList: 'LLM_TRANSFER_USER_LIST',
  userPwdInfo: 'LLM_USER_PWD_INFO',
  userAccounts: 'LLM_USER_ACCOUNTS',
  token: 'LLM_TOKEN',
  bindAlertTime: 'LLM_BIND_ALERT_TIME',
  ossPath: 'LLM_OSS_PATH',
  ossInfo: 'LLM_OSS_INFO',
  lang: 'LLM_LANG',
  drak: 'LLM_DRAK',
  tabNav: 'LLM_TAB_NAV',
  loginAcctount: 'LLM_LOGIN_ACCTOUNT',
}

export default {
  _getCacheInfo() {
    if (window.ChromeSDK) {
      if (typeof window.ChromeSDK.cacheinfo === "string" && window.ChromeSDK.cacheinfo !== '') {
        const t = utils.getClientFn('decrypt', window.ChromeSDK.cacheinfo).value
        try {
          return JSON.parse(t)
        } catch (e) {
          return {}
        }
      } else {
        return {}
      }
    }
  },

  /**
   * 设置
   * @param name
   * @param data
   */
  setItem(name, data) {
    const s = typeof data === 'string' ? data : JSON.stringify(data)
    if (window.ChromeSDK) {
      const t = this._getCacheInfo()
      t[name] = s
      window.ChromeSDK.cacheinfo = utils.getClientFn('encrypt', JSON.stringify(t)).value
    } else {
      localStorage.setItem(name, data)
    }
  },

  /**
   * 获取
   * @param name
   * @returns {string|*}
   */
  getItem(name) {
    if (window.ChromeSDK) {
      const t = this._getCacheInfo()
      return t[name] || ''
    } else {
      return localStorage.getItem(name)
    }
  },

  /**
   * 删除
   * @param name
   */
  removeItem(name) {
    if (window.ChromeSDK) {
      const t = this._getCacheInfo()
      delete t[name]
      window.ChromeSDK.cacheinfo = JSON.stringify(utils.getClientFn('encrypt', JSON.stringify(t)).value)
    } else {
      return localStorage.removeItem(name)
    }
  },

  // 分享用户列表
  setShareUserList(userinfo) {
    this.setItem(types.shareUserList, JSON.stringify(userinfo))
  },
  getShareUserList() {
    return JSON.parse(this.getItem(types.shareUserList) || '[]') || []
  },
  removeShareUserList() {
    this.removeItem(types.shareUserList)
  },

  // 移动端子帐户详情
  setMobileAccountInfo(userinfo) {
    this.setItem(types.mobileAccountInfo, JSON.stringify(userinfo))
  },
  getMobileAccountInfo() {
    return JSON.parse(this.getItem(types.mobileAccountInfo) || '{}') || {}
  },
  removeMobileAccountInfo() {
    this.removeItem(types.mobileAccountInfo)
  },

  // 移动端支付信息
  setMobilePayInfo(userinfo) {
    this.setItem(types.mobilePayInfo, JSON.stringify(userinfo))
  },
  getMobilePayInfo() {
    return JSON.parse(this.getItem(types.mobilePayInfo) || '{}') || {}
  },
  removeMobilePayInfo() {
    this.removeItem(types.mobilePayInfo)
  },

  // 移动端支付信息
  setMobilePayNewInfo(userinfo) {
    this.setItem(types.mobilePayNewInfo, JSON.stringify(userinfo))
  },
  getMobilePayNewInfo() {
    return JSON.parse(this.getItem(types.mobilePayNewInfo) || '{}') || {}
  },
  removeMobilePayNewInfo() {
    this.removeItem(types.mobilePayNewInfo)
  },

  // 转发用户列表
  setTransferUserinfo(userinfo) {
    this.setItem(types.transferUserList, JSON.stringify(userinfo))
  },
  getTransferUserinfo() {
    return JSON.parse(this.getItem(types.transferUserList) || '[]') || []
  },
  removeTransferUserinfo() {
    this.removeItem(types.transferUserList)
  },

  // 登录信息缓存
  setUserinfo(userinfo) {
    this.setItem(types.userinfo, JSON.stringify(userinfo))
  },
  getUserinfo() {
    return JSON.parse(this.getItem(types.userinfo) || '{}') || {}
  },
  removeUserinfo() {
    this.removeItem(types.userinfo)
  },

  // 帐号、密码、token缓存
  setUserPwdinfo(userinfo) {
    this.setItem(types.userPwdInfo, JSON.stringify(userinfo))
  },
  getUserPwdinfo() {
    return JSON.parse(this.getItem(types.userPwdInfo) || '{}') || {}
  },
  removeUserPwdinfo() {
    this.removeItem(types.userPwdInfo)
  },

  /**
   * 登录的帐号
   * @param acctount
   */
  setLoginAcctount(acctount) {
    this.setItem(types.loginAcctount, acctount)
  },
  getLoginAcctount() {
    return this.getItem(types.loginAcctount) || ''
  },
  removeLoginAcctount() {
    this.removeItem(types.loginAcctount)
  },

  /**
   * 存储用户所有登录的帐户信息
   * 数据格式：{xx: {account,passwd,isKeep}}
   * @param userinfo
   */
  setUserAccounts(userinfo) {
    this.setItem(types.userAccounts, JSON.stringify(userinfo))
  },
  getUserAccounts() {
    return JSON.parse(this.getItem(types.userAccounts) || '{}') || {}
  },
  removeUserAccounts() {
    this.removeItem(types.userAccounts)
  },

  // OSS
  setOssinfo(userinfo) {
    this.setItem(types.ossInfo, JSON.stringify(userinfo))
  },
  getOssinfo() {
    return JSON.parse(this.getItem(types.ossInfo) || '{}') || null
  },
  removeOssinfo() {
    this.removeItem(types.ossInfo)
  },

  // tabNav
  settabNav(data) {
    const u = this.getLoginAcctount()
    let n = this.getItem(types.tabNav)

    n = n ? JSON.parse(n) : {}
    n[u] = data
    this.setItem(types.tabNav, JSON.stringify(n))
  },
  gettabNav() {
    const u = this.getLoginAcctount()
    let n = this.getItem(types.tabNav)
    n = n ? JSON.parse(n) : {}
    const t = n && n[u]
    return t ? t : false
  },
  removetabNav() {
    this.removeItem(types.tabNav)
  },

  // 明暗
  setdark(dark) {
    this.setItem(types.dark, dark)
  },
  getdark() {
    return this.getItem(types.dark) || 'night'
  },
  removedark() {
    this.removeItem(types.dark)
  },

  // 语言
  setLang(lang) {
    this.setItem(types.lang, lang)
  },
  getLang() {
    return this.getItem(types.lang)
  },
  removeLang() {
    this.removeItem(types.lang)
  },

  // token
  setToken(token) {
    this.setItem(types.token, token)
  },
  getToken() {
    return this.getItem(types.token)
  },
  removeToken() {
    this.removeItem(types.token)
  },

  // 绑定提示时间
  setBindAlertTime(time) {
    const u = this.getLoginAcctount()
    let n = this.getItem(types.bindAlertTime)

    n = n ? JSON.parse(n) : {}
    n[u] = time

    this.setItem(types.bindAlertTime, JSON.stringify(n))
  },
  getBindAlertTime() {
    const u = this.getLoginAcctount()
    let n = this.getItem(types.bindAlertTime)
    n = n ? JSON.parse(n) : {}
    const t = n && n[u]
    return t ? t : 0
  },
  removeBindAlertTime() {
    this.removeItem(types.bindAlertTime)
  },

  // ossPath
  setOssPath(path) {
    this.setItem(types.ossPath, path)
  },
  getOssPath() {
    return this.getItem(types.ossPath)
  },
  removeOssPath() {
    this.removeItem(types.ossPath)
  },

  clearHistory() {
    for (let i in types) {
      this.removeItem(i)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js